<div id="create-user">
  <div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-primary">
      <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
        <span class="title dialog-title">
          {{ 'USERS.CREATEUSER.ADD.TITLE' | translate }}</span
        >
        <button
          mat-icon-button
          (click)="matDialogRef.close()"
          aria-label="Close dialog">
          <mat-icon>close</mat-icon>
        </button>
      </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="user-form">
      <form
        id="addUserForm"
        fxLayout="column"
        fxFill
        [formGroup]="addUserForm"
        (ngSubmit)="onSubmit()">
        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex appearance="outline">
            <mat-label>{{ 'USERS.SINGLE.INFO.AVS' | translate }}</mat-label>
            <input autoComplete="on" matInput formControlName="avs" required />
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex appearance="outline">
            <mat-label>{{
              'USERS.SINGLE.INFO.OFFICIALFIRSTNAME' | translate
            }}</mat-label>
            <input
              autoComplete="on"
              matInput
              formControlName="officialFirstName"
              required />
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex appearance="outline">
            <mat-label>
              {{ 'USERS.SINGLE.INFO.OFFICIALLASTNAME' | translate }}</mat-label
            >
            <input
              autoComplete="on"
              matInput
              formControlName="officialLastName"
              required />
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex appearance="outline">
            <mat-label>
              {{ 'USERS.SINGLE.INFO.FIRSTNAME' | translate }}
            </mat-label>
            <input
              autoComplete="on"
              matInput
              formControlName="firstName"
              required />
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex appearance="outline">
            <mat-label
              >{{ 'USERS.SINGLE.INFO.LASTNAME' | translate }}
            </mat-label>
            <input
              autoComplete="on"
              matInput
              formControlName="lastName"
              required />
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex appearance="outline">
            <mat-label>{{ 'USERS.SINGLE.INFO.TITLE' | translate }} </mat-label>
            <input autoComplete="on" matInput formControlName="title" />
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex appearance="outline">
            <mat-label
              >{{ 'USERS.SINGLE.INFO.DATEOFBIRTH' | translate }}
            </mat-label>
            <input
              autoComplete="on"
              matInput
              formControlName="dateOfBirth"
              required
              placeholder="dd.mm.yyyy" />
          </mat-form-field>
        </div>

        <mat-form-field fxFlex="32" appearance="outline">
          <mat-select
            placeholder="{{ 'USERS.SINGLE.INFO.GENDER' | translate }}*"
            formControlName="gender"
            required>
            <mat-option [value]="'M'">
              {{ 'USERS.CREATEUSER.ADD.GENDER-M' | translate }}
            </mat-option>
            <mat-option [value]="'F'">
              {{ 'USERS.CREATEUSER.ADD.GENDER-F' | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label> {{ 'USERS.SINGLE.INFO.ADDRESS' | translate }}</mat-label>
          <input autoComplete="on" matInput formControlName="address" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'USERS.SINGLE.INFO.NPA' | translate }}</mat-label>
          <input autoComplete="on" matInput formControlName="zip" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'USERS.SINGLE.INFO.LOCALITY' | translate }}</mat-label>
          <input autoComplete="on" matInput formControlName="locality" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            'USERS.SINGLE.INFO.PREFERREDLANGUAGE' | translate
          }}</mat-label>
          <mat-select formControlName="preferredLanguage">
            @for (lang of preferredLanguage; track lang) {
              <mat-option [value]="lang" required>
                {{ lang.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex="32" appearance="outline">
          <mat-select
            placeholder="{{ 'PROFILE.FORM.STRONG_AUTH' | translate }}*"
            formControlName="f2aCondition"
            required>
            <mat-option [value]="'App'"> App </mat-option>
            <mat-option [value]="'SMS'"> SMS </mat-option>
            <mat-option [value]="'Token'"> Token </mat-option>
            <mat-option [value]="'NONE'"> NONE </mat-option>
          </mat-select>
        </mat-form-field>

        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex="32" appearance="outline">
            <mat-select placeholder="Indicatif" formControlName="defaultDial">
              <mat-option [value]="'+41'"> +41 </mat-option>
              <mat-option [value]="'+33'"> +33 </mat-option>
              <mat-option [value]="'+49'"> +49 </mat-option>
              <mat-option [value]="'+39'"> +39 </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field fxFlex="68" appearance="outline">
            <mat-label>{{ 'USERS.SINGLE.INFO.PHONE' | translate }}</mat-label>
            <input
              autoComplete="on"
              matInput
              formControlName="phone"
              [maxLength]="maxlength"
              placeholder="791234567" />
            <mat-error>{{ 'ERROR.PHONE' | translate }}</mat-error>
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline">
          <mat-label>{{
            'USERS.CREATEUSER.ADD.GRPETAB' | translate
          }}</mat-label>
          <mat-select
            fxFill
            formControlName="grpEtablissement"
            [value]="selectedGE"
            (selectionChange)="onChangeEtablissement($event)">
            @for (
              etablissement of currentUser.groupEtablissement;
              track etablissement
            ) {
              <mat-option [value]="etablissement">{{
                etablissement
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'USERS.SINGLE.INFO.ROLES' | translate }}</mat-label>
          <mat-select fxFill formControlName="roles" multiple>
            @for (role of rolesAvailable; track role) {
              <mat-option [value]="role.name">{{
                role.displayName
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex appearance="outline">
            <mat-label>{{ 'USERS.SINGLE.INFO.EMAIL' | translate }}</mat-label>
            <input
              autoComplete="on"
              matInput
              formControlName="email"
              required />
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex appearance="outline">
            <mat-label>{{ 'USERS.SINGLE.INFO.CLASS' | translate }} </mat-label>
            <input autoComplete="on" matInput formControlName="classe" />
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'USERS.SINGLE.INFO.CANTON' | translate }}</mat-label>
          <mat-select formControlName="canton">
            @for (canton of cantons; track canton) {
              <mat-option [value]="canton">
                {{ canton }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field
            fxFlex="90"
            appearance="outline"
            class="field-container">
            <mat-label>{{
              'USERS.SINGLE.INFO.PASSWORD' | translate
            }}</mat-label>

            <app-pass-visibility #toggle matSuffix></app-pass-visibility>

            <input
              autoComplete="on"
              matInput
              formControlName="password"
              required
              [type]="toggle.type"
              placeholder="Password" />

            @if (addUserForm.get('password').invalid) {
              <mat-error class="error-password">
                {{ getErrorMessage() }}
              </mat-error>
            }
          </mat-form-field>
          <div
            fxFlex="10"
            fxLayoutAlign="center center"
            class="container-form-tooltip">
            <mat-icon
              matTooltip="{{ 'USERS.CREATEUSER.ADD.PWDTOOLTIP' | translate }}"
              class="mat-icon-custom"
              >help</mat-icon
            >
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field appearance="outline" class="field-container">
            <mat-label>{{
              'USERS.SINGLE.INFO.PWDCONFIRM' | translate
            }}</mat-label>

            <app-pass-visibility #toggleConfirm matSuffix></app-pass-visibility>

            <input
              autoComplete="on"
              matInput
              formControlName="passwordConfirmation"
              required
              [type]="toggleConfirm.type"
              placeholder="Password" />
          </mat-form-field>
        </div>
        <div class="error-container">
          @if (addUserForm.hasError('passwordNotMatch')) {
            <mat-error class="message-box error">
              {{ 'ERROR.IDENTICALPSWD' | translate }}
            </mat-error>
          }
        </div>

        @if (addUserForm.errors?.['firstNameNotMatch']) {
          <mat-error>
            {{ 'ERROR.FIRSTNAME' | translate }}
          </mat-error>
        }
        @if (addUserForm.errors?.['lastNameNotMatch']) {
          <mat-error>
            {{ 'ERROR.LASTNAME' | translate }}
          </mat-error>
        }
        @if (addUserForm.errors?.['firstNameHasDuplicates']) {
          <mat-error>
            {{ 'ERROR.FIRSTNAME_MULTIPLE' | translate }}
          </mat-error>
        }
        @if (addUserForm.errors?.['lastNameHasDuplicates']) {
          <mat-error>
            {{ 'ERROR.LASTNAME_MULTIPLE' | translate }}
          </mat-error>
        }
      </form>
    </div>

    @if (isBusy) {
      <div
        class="general-container"
        fxLayout="row"
        fxLayoutAlign="center center">
        <mat-progress-spinner
          [color]="spinner.color"
          [mode]="spinner.mode"
          [value]="spinner.value"
          [diameter]="spinner.diameter">
        </mat-progress-spinner>
      </div>
    }

    @if (isErrorUpdate) {
      <div class="general-container" fxLayout="row" fxFill="100">
        <div class="message-box error user-created">
          <app-error-message [error]="error.error" />
        </div>
      </div>
    }

    @if (isUserCreated) {
      <div class="general-container" fxLayout="row" fxFill="100">
        <div class="message-box success user-created">
          {{ 'USERS.CREATEUSER.SUCESS' | translate }} {{ username }}
        </div>
      </div>
    }
    <div
      mat-dialog-actions
      class="button-form"
      fxLayout="row"
      fxLayoutAlign="end center">
      <button
        mat-raised-button
        form="addUserForm"
        type="submit"
        color="accent"
        [disabled]="addUserForm.invalid">
        {{ 'GENERAL.SAVE' | translate }}
      </button>
    </div>
  </div>
</div>
